import { useCandidateHeaderQuery } from "@generated/graphql";
import { Stack, Typography } from "@mui/material";
import useIsCreate from "hooks/useIsCreate";
import useSetTabTitle from "hooks/useSetTabTitle";
import { useParams } from "react-router-dom";

const Header = () => {
  const { candidateId } = useParams();
  const isCreate = useIsCreate();
  const { data } = useCandidateHeaderQuery({ variables: { candidateId: candidateId! } });

  const candidate = data?.companyCandidate;

  const getCandidateTopic = () => {
    if (isCreate) return "";

    return [candidate?.numericId || "", candidate?.fullName || ""].filter((item) => item).join(", ");
  };

  const title = `Кандидат ${getCandidateTopic()}`;

  useSetTabTitle(title, candidate);

  return (
    <Stack
      direction='row'
      alignItems='flex-start'
      spacing={2}>
      <Typography variant='h28'>{title}</Typography>
    </Stack>
  );
};

export default Header;
